import React from "react";

function BS4_Containers() {
  return (
    <div>
      <h1>BS4_Containers Component</h1>
      <p>This is the BS4_Containers tutorial page content.</p>
    </div>
  );
}

export default BS4_Containers;
